module.exports = __webpack_public_path__ + "img/car.50d87440.png";